var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheckCouponArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 8,
    height: 15,
    viewBox: "0 0 8 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.55469 7.92969L1.92969 14.1797C1.69531 14.4531 1.30469 14.4531 1.07031 14.2188C0.796875 13.9844 0.796875 13.5938 1.03125 13.3594L6.26562 7.5L1.03125 1.67969C0.796875 1.44531 0.796875 1.05469 1.07031 0.820312C1.30469 0.585938 1.69531 0.585938 1.92969 0.859375L7.55469 7.07031C7.78906 7.34375 7.78906 7.69531 7.55469 7.92969Z",
    fill: "#858585"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckCouponArrow);
export default __webpack_public_path__ + "static/media/checkCouponArrow.7af95eb4228bee5ce4a7ee1f66bc7c2f.svg";
export { ForwardRef as ReactComponent };